import { render, staticRenderFns } from "./advertConfig.vue?vue&type=template&id=27e49901&scoped=true&"
import script from "./advertConfig.vue?vue&type=script&lang=js&"
export * from "./advertConfig.vue?vue&type=script&lang=js&"
import style0 from "./advertConfig.vue?vue&type=style&index=0&id=27e49901&lang=less&scoped=true&"
import style1 from "./advertConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e49901",
  null
  
)

export default component.exports